import styled from "styled-components";
import { colours } from "../../../../../../styles/colours.constants";
import {
	satoshi500,
	satoshi700,
} from "../../../../../../styles/font.constants";

type PlayerStyleProps = {
	$showBottomBorder: boolean;
};

export const Player = styled.div<PlayerStyleProps>`
	width: 100%;
	padding: 0.55rem 0.625rem;
	display: flex;
	gap: 1rem;
	border-bottom: ${({ $showBottomBorder }) =>
		$showBottomBorder ? "solid 1px #43434433" : "none"};
`;

export const PlayerName = styled.div`
	${satoshi700}
	color: ${colours.black};
`;

export const PlayerPosition = styled.div`
	${satoshi500}
	font-size: 0.75rem;
	color: ${colours.greyDarker};
	margin-top: 0.3rem;
`;

export const PlayerPicture = styled.img`
	border-radius: 100%;
	border: solid 1px ${colours.greyDark};
	background-color: ${colours.greyLight};
	width: 37px;
	height: 37px;
	object-fit: cover;
	flex-shrink: 0;
`;
